<template>
  <!-- 企业文化 -->
  <div class="culture">
    <div class="culture_item" v-for="(item, i) in cultureList" :key="i">
      <img src="../assets/images/icon_about_value.png" alt="" />
      <div class="cu_name">{{ item.title }}</div>
      <span>{{ item.tip }}</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cultureList: [
        {
          url: "../assets/images/icon_about_value.png",
          title: "企业价值观",
          tip: "追求卓越、不断创新",
        },
        {
          url: "../assets/images/icon_about_value.png",
          title: "经营理念",
          tip: "客户满意 是检验我们工作的唯一标准",
        },
        {
          url: "../assets/images/icon_about_value.png",
          title: "使命",
          tip: "用科技及创新护航让安全管理远行",
        },
        {
          url: "../assets/images/icon_about_value.png",
          title: "愿景",
          tip: "做安全领域智能化管理的缔造者",
        },
      ],
    };
  },
  methods:{
    
  }
};
</script>

<style lang="scss">
.culture {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  color: #808080;
  .culture_item {
    width: 306px;
    height: 210px;
    padding: 50px 10% 120px;
    background: #ffffff;
    box-shadow: 0px 2px 70px 0px rgba(0, 0, 0, 0.07);
    margin: 0 0px 40px;

    color: #2f2f2f;
  }
  span {
    font-size: 26px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #808080;
  }
  .culture_item:nth-child(1) {
    background-image: url("../assets/images/bg_about01.png");
    color: #ffffff;
    span {
      color: #ffffff;
    }
  }

  .cu_name {
    font-size: 26px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    margin: 20px 0;
  }
}
@media screen and (max-width: 1366px){
  img{
    width: 120px;
  }
  
}
</style>


// WEBPACK FOOTER //
// src/components/culture.vue